import React from "react";

const MainContent = () => {
  return (
    <main className="flex-grow">
      {/* Hero Section */}
      <section className="gradient-bg">
        <div className="container mx-auto px-6 pt-24 pb-16 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-slate-800 dark:text-slate-100 mb-6 leading-tight">
            Explore our professional
            <br />
            supplies brochure
          </h1>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto mb-10 font-light">
            Discover a wide range of high-quality products designed for your
            business needs. Clean, efficient, and reliable.
          </p>
          <a
  href="https://impulse-website-product-catalogue.s3.ap-south-1.amazonaws.com/impulse+2025.pdf"
  className="inline-flex items-center justify-center bg-primary text-white font-normal py-3 px-8 rounded-lg shadow-lg hover:opacity-90 transition-all transform hover:-translate-y-1"
  target="_blank"
  rel="noopener noreferrer"
  download="Impulse-Product-Catalogue-2025.pdf"
>
  <span className="material-icons mr-2">download</span>
  Download Brochure
</a>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-16 sm:py-24 bg-white dark:bg-slate-900/50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 dark:text-slate-100 mb-4">
              Our Product Categories
            </h2>
            <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto font-light">
              Find exactly what you need from our curated selection of
              professional supplies.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-6">
            {/* Machines */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-teal-300 dark:hover:border-teal-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-teal-100 dark:bg-teal-900/50 text-teal-500">
                <span className="material-icons text-3xl">
                  precision_manufacturing
                </span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-teal-600 dark:group-hover:text-teal-400 transition-colors">
                Machines
              </h3>
            </a>

            {/* Housekeeping */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-yellow-300 dark:hover:border-yellow-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 dark:bg-yellow-900/50 text-yellow-500">
                <span className="material-icons text-3xl">cleaning_services</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-yellow-600 dark:group-hover:text-yellow-400 transition-colors">
                Housekeeping
              </h3>
            </a>

            {/* Mops & Brushes */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-pink-300 dark:hover:border-pink-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-pink-100 dark:bg-pink-900/50 text-pink-500">
                <span className="material-icons text-3xl">mop</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-pink-600 dark:group-hover:text-pink-400 transition-colors">
                Mops &amp; Brushes
              </h3>
            </a>

            {/* Dustbins */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-blue-300 dark:hover:border-blue-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-500">
                <span className="material-icons text-3xl">delete</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                Dustbins
              </h3>
            </a>

            {/* Hygiene */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-green-300 dark:hover:border-green-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-100 dark:bg-green-900/50 text-green-500">
                <span className="material-icons text-3xl">sanitizer</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-green-600 dark:group-hover:text-green-400 transition-colors">
                Hygiene
              </h3>
            </a>

            {/* Cleaning Chemicals */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-indigo-300 dark:hover:border-indigo-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-indigo-100 dark:bg-indigo-900/50 text-indigo-500">
                <span className="material-icons text-3xl">science</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                Cleaning Chemicals
              </h3>
            </a>

            {/* Linens */}
            <a
              href="#"
              className="group block text-center p-4 bg-slate-50 dark:bg-slate-800 rounded-lg hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-slate-200 dark:border-slate-700 hover:border-red-300 dark:hover:border-red-500"
            >
              <div className="mb-3 inline-flex items-center justify-center h-16 w-16 rounded-full bg-red-100 dark:bg-red-900/50 text-red-500">
                <span className="material-icons text-3xl">bed</span>
              </div>
              <h3 className="font-normal text-slate-700 dark:text-slate-200 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors">
                Linens
              </h3>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MainContent;
